export { default } from './DPAList.js';